// test1791
(1791 && 0);
